import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DictionaryTag, SchoolDictionary } from '@digilize/language-school/definitions';

@Injectable({
  providedIn: 'root',
})
export class SchoolDictionaryApiService {
  constructor(private http: HttpClient) {}

  getDictionary = () => this.http.get<SchoolDictionary>(`/api/v1.0/school-dictionary`);

  getTag = (tagId: string) => this.http.get<DictionaryTag[]>(`/api/v1.0/school-dictionary/tag/${tagId}`);
}
